<template>
  <Layout>
    <div class="dispatcher">
      <DispatcherSidebar
        :sections="sections"
        :collapsed="collapsed"
        :active-route-name="$route.name"
        @toggle="toggleSidebar"
        @select="goTo"
      />
      <div class="dispatcher__body">
        <router-view :layout-version="layoutVersion" />
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main';
import DispatcherSidebar from '@/components/management/dispatcher/DispatcherSidebar.vue';
import { allowedSections, readAccessItems } from '@/components/management/dispatcher/access';

const STORAGE_KEY = 'dispatcher.sidebarCollapsed';

export default {
  name: 'DispatcherShell',
  components: { Layout, DispatcherSidebar },
  data() {
    let collapsed = false;
    try { collapsed = window.localStorage.getItem(STORAGE_KEY) === 'true'; } catch (e) { collapsed = false; }
    return {
      sections: allowedSections(readAccessItems()),
      collapsed,
      layoutVersion: 0,
    };
  },
  methods: {
    toggleSidebar() {
      this.collapsed = !this.collapsed;
      try { window.localStorage.setItem(STORAGE_KEY, String(this.collapsed)); } catch (e) { /* storage unavailable */ }
      this.layoutVersion += 1;
    },
    goTo(section) {
      // vue-router 3.5 rejects `push()` when a guard aborts with `next(false)` — the designed
      // path when MapSection has an open draft. Nothing to report, so swallow it.
      if (this.$route.name !== section.routeName) this.$router.push({ name: section.routeName }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
/* .page-content (horizontal layout) = margin-top 70px header + padding-top (55px topnav + 24px gutter) + padding-bottom 60px footer */
.dispatcher {
  display: flex;
  height: calc(100vh - 209px);
  min-height: 480px;
  background: #f4f5f1;
  border: 1px solid #e3e5e1;
  border-radius: 8px;
  overflow: hidden;
}
.dispatcher__body {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 12px;
}
</style>
